<template>
  <svg viewBox="0 0 32 32" v-on="$listeners">
    <path
      d="M28.681 7.159c-0.694-0.947-1.662-2.053-2.724-3.116s-2.169-2.030-3.116-2.724c-1.612-1.182-2.393-1.319-2.841-1.319h-15.5c-1.378 0-2.5 1.121-2.5 2.5v27c0 1.378 1.121 2.5 2.5 2.5h23c1.378 0 2.5-1.122 2.5-2.5v-19.5c0-0.448-0.137-1.23-1.319-2.841v0 0zM24.543 5.457c0.959 0.959 1.712 1.825 2.268 2.543h-4.811v-4.811c0.718 0.556 1.584 1.309 2.543 2.268v0 0zM28 29.5c0 0.271-0.229 0.5-0.5 0.5h-23c-0.271 0-0.5-0.229-0.5-0.5v-27c0-0.271 0.229-0.5 0.5-0.5 0 0 15.499-0 15.5 0v7c0 0.552 0.448 1 1 1h7v19.5z"
    ></path>
    <path d="M8 2h4v2h-4v-2z"></path>
    <path d="M12 4h4v2h-4v-2z"></path>
    <path d="M8 6h4v2h-4v-2z"></path>
    <path d="M12 8h4v2h-4v-2z"></path>
    <path d="M8 10h4v2h-4v-2z"></path>
    <path d="M12 12h4v2h-4v-2z"></path>
    <path d="M8 14h4v2h-4v-2z"></path>
    <path d="M12 16h4v2h-4v-2z"></path>
    <path
      d="M8 26.5c0 0.825 0.675 1.5 1.5 1.5h5c0.825 0 1.5-0.675 1.5-1.5v-5c0-0.825-0.675-1.5-1.5-1.5h-2.5v-2h-4v8.5zM14 24v2h-4v-2h4z"
    ></path>
  </svg>
</template>

<script>
export default {
  name: 'activate-user',
}
</script>